import React, { lazy } from 'react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function WhatYouReceive() {
  return <section className="w-full pt-4 md:pt-6 pb-12 md:pb-16 px-4 bg-[#000000]" data-id="element-421">
      <div className="max-w-3xl mx-auto" data-id="element-422">
        <div className="text-center mb-10" data-id="element-423">
          <h2 className="text-3xl md:text-4xl font-black font-heading mb-2 bg-[#000000] text-[#F9FAFA]" data-id="element-424">
            📦 LO QUE RECIBES
          </h2>
          <p className="md:text-2xl font-heading bg-[#0C0C0C] text-[16px] font-[700] text-[#E92E2E]" data-id="element-425">
            5 TOMOS COMPLETOS + 3 BONOS
          </p>
        </div>

        {/* Tomo 1 */}
        <div className="bg-blue-50 rounded-2xl p-6 mb-6 border-2 border-blue-200" data-id="element-426">
          <div className="flex flex-col md:flex-row items-center gap-6 text-[#FFFFFF] bg-[#EFF6FF]" data-id="element-427">
            <img src="https://cdn.magicpatterns.com/uploads/rLhyR1EA3cgTXTqTFjho23/tomo_1.png" alt="Tomo 1 - Entender" className="w-40 md:w-48 flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300 drop-shadow-lg text-[#FFFFFF]" onClick={scrollToPricing} loading="lazy" decoding="async" width={192} height={192} data-id="element-428" />
            <div data-id="element-429">
              <h3 className="text-xl md:text-2xl font-black font-heading text-blue-800 mb-2" data-id="element-430">
                📘 TOMO 1 — ENTENDER
              </h3>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-431">
                Descubre qué está pasando realmente con tu hijo y por qué su
                comportamiento no es "mala conducta", sino una forma de expresar
                lo que no puede gestionar.
              </p>
            </div>
          </div>
        </div>

        {/* Tomo 2 */}
        <div className="bg-yellow-50 rounded-2xl p-6 mb-6 border-2 border-yellow-200" data-id="element-432">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-433">
            <img src="https://cdn.magicpatterns.com/uploads/gfRcH6TLaLWXiN6sVFeaUP/tomo_2.png" alt="Tomo 2 - Regular" className="w-40 md:w-48 flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300 drop-shadow-lg" onClick={scrollToPricing} loading="lazy" decoding="async" width={192} height={192} data-id="element-434" />
            <div data-id="element-435">
              <h3 className="text-xl md:text-2xl font-black font-heading text-yellow-800 mb-2" data-id="element-436">
                📗 TOMO 2 — REGULAR
              </h3>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-437">
                Aprende a calmar sin gritos, acompañar emociones intensas y
                ayudar a tu hijo a recuperar el control sin conflictos.
              </p>
            </div>
          </div>
        </div>

        {/* Tomo 3 */}
        <div className="bg-orange-50 rounded-2xl p-6 mb-6 border-2 border-orange-200" data-id="element-438">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-439">
            <img src="https://cdn.magicpatterns.com/uploads/qPwAiPYJp3YrvSSD6YXGGo/tomo_3.png" alt="Tomo 3 - Rutinas" className="w-40 md:w-48 flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300 drop-shadow-lg" onClick={scrollToPricing} loading="lazy" decoding="async" width={192} height={192} data-id="element-440" />
            <div data-id="element-441">
              <h3 className="text-xl md:text-2xl font-black font-heading text-orange-800 mb-2" data-id="element-442">
                📙 TOMO 3 — RUTINAS
              </h3>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-443">
                Implementa estructuras simples y efectivas que ordenan el día y
                reducen el caos sin necesidad de repetir todo el tiempo.
              </p>
            </div>
          </div>
        </div>

        {/* Tomo 4 */}
        <div className="bg-red-50 rounded-2xl p-6 mb-6 border-2 border-red-200" data-id="element-444">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-445">
            <img src="https://cdn.magicpatterns.com/uploads/fdNXoup2EM6Gvqoa6fnbdA/tomo_4.png" alt="Tomo 4 - Límites" className="w-40 md:w-48 flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300 drop-shadow-lg" onClick={scrollToPricing} loading="lazy" decoding="async" width={192} height={192} data-id="element-446" />
            <div data-id="element-447">
              <h3 className="text-xl md:text-2xl font-black font-heading text-red-800 mb-2" data-id="element-448">
                📕 TOMO 4 — LÍMITES
              </h3>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-449">
                Establece límites claros y firmes sin castigos ni peleas,
                logrando cooperación desde la conexión.
              </p>
            </div>
          </div>
        </div>

        {/* Tomo 5 */}
        <div className="rounded-2xl p-6 mb-6 border-2 border-purple-200 bg-[#ECF9FF]" data-id="element-450">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-451">
            <img src="https://cdn.magicpatterns.com/uploads/czzpQXYoUy7gjkzShMsamg/tomo_5.png" alt="Tomo 5 - Energía" className="w-40 md:w-48 flex-shrink-0 cursor-pointer hover:scale-105 transition-transform duration-300 drop-shadow-lg" onClick={scrollToPricing} loading="lazy" decoding="async" width={192} height={192} data-id="element-452" />
            <div data-id="element-453">
              <h3 className="text-xl md:text-2xl font-black font-heading mb-2 text-[#229DD6] bg-[#00000000]" data-id="element-454">
                📓 TOMO 5 — ENERGÍA
              </h3>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-455">
                Canaliza la energía de tu hijo de forma positiva para evitar
                explosiones y mejorar su comportamiento diario.
              </p>
            </div>
          </div>
        </div>

        {/* What each tomo includes */}
        <div className="bg-green-50 rounded-2xl p-6 md:p-8 mt-8 border-2 border-green-200" data-id="element-456">
          <h3 className="text-xl md:text-2xl font-black font-heading text-gray-900 mb-4 text-center" data-id="element-457">
            Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-458">
            <div className="flex items-start gap-3" data-id="element-459">
              <span className="text-green-600 text-xl flex-shrink-0" data-id="element-460">✅</span>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-461">
                Explicación clara (sin tecnicismos)
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-462">
              <span className="text-green-600 text-xl flex-shrink-0" data-id="element-463">✅</span>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-464">
                Ejercicios prácticos aplicables
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-465">
              <span className="text-green-600 text-xl flex-shrink-0" data-id="element-466">✅</span>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-467">
                Ejemplos reales
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-468">
              <span className="text-green-600 text-xl flex-shrink-0" data-id="element-469">✅</span>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-470">
                Estrategias listas para usar
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-471">
              <span className="text-green-600 text-xl flex-shrink-0" data-id="element-472">✅</span>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-473">
                Lenguaje simple y directo
              </p>
            </div>
          </div>
        </div>

        {/* Persuasive CTA */}
        <div className="text-center mt-10" data-id="element-474">
          <button onClick={scrollToPricing} className="w-full md:w-auto bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-lg md:text-xl px-8 py-5 rounded-xl shadow-lg animate-pulse-glow transition-colors duration-200 cursor-pointer font-heading" data-id="element-475">
            👉 QUIERO TRANSFORMAR MI HOGAR AHORA
          </button>
        </div>
      </div>
    </section>;
}